import TextEditor from './components/TextEditor'
import './App.css'

const App = () => <TextEditor />

export default App
